import * as React from "react";
function SvgIcRewind(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.39 4L4 12l8.39 8v-7.28L20 20V4l-7.61 7.28V4zm-1.066 2.443L5.496 12l5.828 5.557V6.443zM13.13 12l5.803-5.551v11.102L13.13 12z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcRewind;
